import { Routes, RouterModule } from '@angular/router';
import { EmailConfigurationScreenComponent } from './email-configuration.component';

const emailConfigurationRoutes: Routes = [
];

export const EmailConfigurationRouter = RouterModule.forChild(emailConfigurationRoutes);